<template>
 <admin-header></admin-header>
 <admin-sidebar></admin-sidebar>
  <div class="page-wrapper">
    <div class="content pb-0 me-4">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Remix Icon</h3>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <div class="row">
        <!-- Icons -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Remix Icons</div>
            </div>
            <div class="card-body">
              <p class="mb-2">
                <code>&lt;i class="ri-ICON_NAME"&gt;&lt;/i&gt;</code>. For more
                information
                <a href="https://remixicon.com/" target="_blank" class="text-primary"
                  >click here</a
                >.
              </p>
              <div class="icons-items">
                <div class="icons-list">
                  <div class="icons-list-item">
                    <i
                      class="ri-home-line"
                      data-bs-toggle="tooltip"
                      title="ri-home-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-dashboard-3-line"
                      data-bs-toggle="tooltip"
                      title="ri-dashboard-3-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-map-pin-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-map-pin-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-message-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-message-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-group-line"
                      data-bs-toggle="tooltip"
                      title="ri-group-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-image-line"
                      data-bs-toggle="tooltip"
                      title="ri-image-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-file-line"
                      data-bs-toggle="tooltip"
                      title="ri-file-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-line-chart-line"
                      data-bs-toggle="tooltip"
                      title="ri-line-chart-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-exchange-line"
                      data-bs-toggle="tooltip"
                      title="ri-exchange-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-menu-line"
                      data-bs-toggle="tooltip"
                      title="ri-menu-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-settings-5-line"
                      data-bs-toggle="tooltip"
                      title="ri-settings-5-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-building-4-line"
                      data-bs-toggle="tooltip"
                      title="ri-building-4-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-shopping-cart-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-shopping-cart-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-video-chat-line"
                      data-bs-toggle="tooltip"
                      title="ri-video-chat-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-notification-3-line"
                      data-bs-toggle="tooltip"
                      title="ri-notification-3-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-mail-settings-line"
                      data-bs-toggle="tooltip"
                      title="ri-mail-settings-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-map-pin-line"
                      data-bs-toggle="tooltip"
                      title="ri-map-pin-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-pie-chart-line"
                      data-bs-toggle="tooltip"
                      title="ri-pie-chart-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-checkbox-line"
                      data-bs-toggle="tooltip"
                      title="ri-checkbox-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-check-double-line"
                      data-bs-toggle="tooltip"
                      title="ri-check-double-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-archive-line"
                      data-bs-toggle="tooltip"
                      title="ri-archive-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-arrow-down-s-line"
                      data-bs-toggle="tooltip"
                      title="ri-arrow-down-s-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-arrow-right-double-fill"
                      data-bs-toggle="tooltip"
                      title="ri-arrow-right-double-fill"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-download-cloud-line"
                      data-bs-toggle="tooltip"
                      title="ri-download-cloud-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-database-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-database-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-computer-line"
                      data-bs-toggle="tooltip"
                      title="ri-computer-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-discount-percent-line"
                      data-bs-toggle="tooltip"
                      title="ri-discount-percent-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-more-2-fill"
                      data-bs-toggle="tooltip"
                      title="ri-more-2-fill"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-download-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-download-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-delete-bin-line"
                      data-bs-toggle="tooltip"
                      title="ri-delete-bin-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-folder-open-line"
                      data-bs-toggle="tooltip"
                      title="ri-folder-open-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-calendar-2-line"
                      data-bs-toggle="tooltip"
                      title="ri-calendar-2-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-calculator-line"
                      data-bs-toggle="tooltip"
                      title="ri-calculator-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-time-line"
                      data-bs-toggle="tooltip"
                      title="ri-time-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-phone-line"
                      data-bs-toggle="tooltip"
                      title="ri-phone-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ri-video-on-line"
                      data-bs-toggle="tooltip"
                      title="ri-video-on-line"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /icons -->
      </div>
    </div>

    <!-- Footer-->
    <div class="footer d-sm-flex align-items-center justify-content-between bg-white p-3">
      <p class="mb-0">
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);" class="ms-4">Terms of Use</a>
      </p>
      <p>
        &copy; 2025 Dreamsrent, Made with <span class="text-danger">❤</span> by
        <a href="javascript:void(0);" class="text-secondary">Dreams</a>
      </p>
    </div>
    <!-- /Footer-->
  </div>
</template>
